module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Payout","amount":"Amount"},"et":{"title":"Payout","amount":"Amount"},"ru":{"title":"Payout","amount":"Amount"}}')
  delete Component.options._Ctor
}
